import * as React from "react";

import { TourStepsContext } from "./TourStepsContext";

export const TourStepsContextObject = React.createContext<undefined | TourStepsContext>(undefined);
